import axios from "axios";

const API = axios.create({
  baseURL:
    process.env.NODE_ENV === "production"
      ? "https://polybionictechnologies.com/api"
      : "http://localhost:5001/api",
});

// Automatically attach JWT token
API.interceptors.request.use((req) => {
  const token = localStorage.getItem("token");

  if (token) {
    req.headers.Authorization = `Bearer ${token}`;
  }

  return req;
});

// Contact
export const contactForm = (data) => API.post("/contact", data);

// Auth
export const Register = (data) => API.post("/auth/register", data);

export const Authlogin = (data) => API.post("/auth/login", data);

// Orders
export const createOrder = (data) => API.post("/orders/create", data);

export const createPaymentOrder = (data) =>
  API.post("/payment/create-order", data);

export const verifyPayment = (data) =>
  API.post("/payment/verify-payment", data);

export const verifycreateOrder = (data) =>
  API.post("/payment/verify-payment", data);
export const getMyOrders = () => API.get("/orders/my-orders");

export const getOrderById = (orderId) => API.get(`/orders/${orderId}`);

export const CreateProduct = async (data) => {
  return API.post("/product/create", data);
};
export const getOrderInvoice = async (orderId) => {
  return API.get(`/orders/invoice/${orderId}`, {
    responseType: "blob",
  });
};
export const GetallProduct = async () => {
  return API.get("/product/all");
};
export const DeleteProduct = async (id) => {
  return API.post(`/product/delete/${id}`);
};
export const EditProduct = async (slug, data) => {
  return API.put(`/product/edit/${slug}`, data);
};
export const GetsingleProduct = (slug) => {
  return API.get(`/product/${slug}`);
};
export const getAllOrders = async () => {
  return API.get("/orders/all");
};
export const updateOrderStatus = async (orderId, status) => {
  return API.put(`/orders/${orderId}/status`, { status });
};

export const cancelOrder = async (orderId) => {
  return API.put(`/orders/${orderId}/cancel`);
};

export const GetSettings = () => API.get("/setting/getSettings");

export const UpdateSettings = (data) => API.put("/setting/updateSettings", data);
export const CreateContact = (data) =>
  API.post("/contact", data);

// Get All Contact Queries
export const GetAllQueries = () =>
  API.get("/contact");

// Get Single Query
export const GetSingleQuery = (id) =>
  API.get(`/contact/${id}`);

// Delete Query
export const DeleteQuery = (id) =>
  API.delete(`/contact/${id}`);

// User
export const returnOrder = (orderId, data) =>
  API.post(`/returns/${orderId}`, data);

// Admin
export const getReturnRequests = () =>
  API.get("/returns");

export const getReturnRequest = (id) =>
  API.get(`/returns/${id}`);

export const updateReturnStatus = (id, data) =>
  API.put(`/returns/${id}`, data);
export default API;
